import React from 'react'
import Button from './Button'
// import BackArrow from './assets/ic_back_arrow.svg'
import './QuantityStepper.scss'
import { IconMinus, IconPlus } from './icons'

interface Props {
  onAddQuantity: (quantity: number) => void
  value: number
}

const iconSize = 16

const QuantityStepper: React.FunctionComponent<Props> = ({ onAddQuantity, value }) => {
  return (
    <div className="QuantityStepper">
      <Button
        round
        onClick={() => onAddQuantity(-1)}
      >
        <img src={IconMinus} alt="-" width={iconSize} height={iconSize} />
      </Button>
      <div className="currentValue">{value}</div>
      <Button
        round
        onClick={() => onAddQuantity(1)}
      >
        <img src={IconPlus} alt="+" width={iconSize} height={iconSize} />
      </Button>
    </div>
  )
}

export default QuantityStepper
